module.exports = __webpack_public_path__ + "static/media/efficient@3x.08d45f91.png";